import { useNavigate } from "react-router-dom";
import FooterBlock from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/Buttons/Action/ActionButton";

const LoggedOutView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <p>{t('error.login')}</p>
      <div className={"button-container"}>
        <ActionButton
          onClick={() => {
            navigate(`/`);
          }}
        >
          {t('common.backToHome')}
        </ActionButton>
      </div>
      <FooterBlock />
    </>
  );
};

export default LoggedOutView;
